export type UnauthorizedUserErrorType = 'unauthorized' | 'secure_storage_token_expired'

export const isUnauthorizedUserErrorType = (
  value: unknown,
): value is UnauthorizedUserErrorType => value === 'unauthorized' || value === 'secure_storage_token_expired'
